<template lang="html">

    <div class="wrapper -equipo">

        <div class="encabezado">

            <div class="container column-start">
                <div class="contenedor-logo">
                    <router-link to="/">
                        <img src="/static/img/UFV-logo.png" alt="Logo UFV">
                    </router-link>
                </div>
                <h1>Equipo</h1>
            </div>

        </div>

        <div class="migas">
            <div class="container">
                <nav class="row-start">
                    <router-link to="/">Home</router-link>
                    <router-link :to="$t('enlaces.equipo')">Equipo</router-link>
                </nav>
            </div>
        </div>






        <section class="-equipocompleto container row-center ais">
            <div class="direccion seccion-equipo">
                <h3>Dirección</h3>
                <img src="/static/img/quienes-somos/marta-montojo.jpg" class="imagen-persona">
                <p class="nombre">Marta Montojo</p>
                <p class="cargo">Directora de Carreras Profesionales UFV</p>
                <div class="linkedln-equipo">
                    <img src="/static/img/logo-linkedln.png">
                    <a href="https://www.linkedin.com/in/martamontojoarteaga/" target="_blank">LinkedIn</a>
                </div>
                <a href="mailto:m.montojo@ufv.es" class="correo-equipo">m.montojo@ufv.es</a>
            </div>
            <h3>Responsables de Carreras Profesionales (Orientación y relación con empresas)</h3>
            <div class="responsables seccion-equipo">
                <div class="persona">
                    <img src="/static/img/quienes-somos/ana-decorral.jpg" class="imagen-persona">
                    <div class="datos">
                        <p class="nombre">Ana de Corral</p>
                        <p class="cargo">Responsable de Carrera Profesional de la Facultad de Derecho, Empresa y
                            Gobierno</p>
                        <div class="linkedln-equipo">
                            <img src="/static/img/logo-linkedln.png">
                            <a href="https://www.linkedin.com/in/anadecorralzunzunegui/" target="_blank">LinkedIn</a>
                        </div>
                        <a href="mailto:a.corral@ufv.es" class="correo-equipo">a.corral@ufv.es</a>
                        <p class="grados">(Grados: Derecho, RRII, FPE, Gastronomía y Criminología)</p>

                    </div>
                </div>
                <div class="persona">
                    <img src="/static/img/quienes-somos/cristina-rodriguez.jpg" class="imagen-persona">
                    <div class="datos">
                        <p class="nombre">Cristina Rodríguez</p>
                        <p class="cargo">Responsable de Carrera Profesional de la Facultad de Derecho, Empresa y
                            Gobierno</p>
                        <div class="linkedln-equipo">
                            <img src="/static/img/logo-linkedln.png">
                            <a href="https://www.linkedin.com/in/cristinarodriguezparedes/" target="_blank">LinkedIn</a>
                        </div>
                        <a href="mailto:c.rodriguezparedes@ufv.es" class="correo-equipo">c.rodriguezparedes@ufv.es</a>
                        <p class="grados">(Grados: ADE, Marketing, Business Analytics, Ciberseguridad)</p>
                    </div>
                </div>
                <div class="persona">
                    <img src="/static/img/quienes-somos/cecilia-dominguez.jpg" class="imagen-persona">
                    <div class="datos">
                        <p class="nombre">Cecilia Domínguez</p>
                        <p class="cargo">Responsable de Carrera Profesional de la Facultad de Comunicación</p>
                        <div class="linkedln-equipo">
                            <img src="/static/img/logo-linkedln.png">
                            <a href="https://www.linkedin.com/in/ceciliadominguezpuerto/" target="_blank">LinkedIn</a>
                        </div>
                        <a href="mailto:c.dominguez@ufv.es" class="correo-equipo">c.dominguez@ufv.es</a>
                    </div>
                </div>
                <div class="persona">
                    <img src="/static/img/quienes-somos/elena-gago.jpg" class="imagen-persona">
                    <div class="datos">
                        <p class="nombre">Elena Gago</p>
                        <p class="cargo">Responsable de Carrera Profesional de la Escuela Politécnica</p>
                        <div class="linkedln-equipo">
                            <img src="/static/img/logo-linkedln.png">
                            <a href="https://www.linkedin.com/in/elenagago/" target="_blank">LinkedIn</a>
                        </div>
                        <a href="mailto:elena.gago@ufv.es" class="correo-equipo">elena.gago@ufv.es</a>
                    </div>
                </div>
                <div class="persona">
                    <img src="/static/img/quienes-somos/veronica-dearozamena.jpg" class="imagen-persona">
                    <div class="datos">
                        <p class="nombre">Verónica de Arozamena</p>
                        <p class="cargo">Responsable de Carrera Profesional de la Facultad de Educación y Psicología</p>
                        <div class="linkedln-equipo">
                            <img src="/static/img/logo-linkedln.png">
                            <a href="https://www.linkedin.com/in/veronicadearozamenasanz/" target="_blank">LinkedIn</a>
                        </div>
                        <a href="mailto:v.arozamena@ufv.es" class="correo-equipo">v.arozamena@ufv.es</a>
                    </div>
                </div>
            </div>



            <h3>Gestión</h3>
            <div class="responsables seccion-equipo">
                <div class="persona">
                    <img src="/static/img/quienes-somos/gema-corces.jpg" class="imagen-persona">
                    <div class="datos">
                        <p class="nombre">Gema Corces</p>
                        <p class="cargo bottom">Gestión</p>
                        <p class="cargo top">Facultad de Derecho, Empresa y Gobierno</p>
                        <div class="linkedln-equipo">
                            <img src="/static/img/logo-linkedln.png">
                            <a href="https://www.linkedin.com/in/gemacorces/" target="_blank">LinkedIn</a>
                        </div>
                        <a href="mailto:gv.corces@ufv.es" class="correo-equipo">gv.corces@ufv.es</a>

                    </div>
                </div>
                <div class="persona">
                    <img src="/static/img/quienes-somos/milagros-gomez.jpg" class="imagen-persona">
                    <div class="datos">
                        <p class="nombre">Milagros Gómez</p>
                        <p class="cargo bottom">Gestión</p>
                        <p class="cargo top">Escuela Politécnica</p>
                       
                        <a href="mailto:m.gomez@ufv.es" class="correo-equipo">m.gomez@ufv.es</a>
                    </div>
                </div>
                <div class="persona">
                    <img src="/static/img/quienes-somos/ana-puentes.jpg" class="imagen-persona">
                    <div class="datos">
                        <p class="nombre">Ana Isabel Puente</p>
                        <p class="cargo bottom">Gestión</p>
                        <p class="cargo top">Facultad de Comunicación</p>
                        <div class="linkedln-equipo">
                            <img src="/static/img/logo-linkedln.png">
                            <a href="https://www.linkedin.com/in/ana-isabel-puente-fr%C3%ADas/" target="_blank">LinkedIn</a>
                        </div>
                        <a href="mailto:anaisabel.puente@ufv.es" class="correo-equipo">anaisabel.puente@ufv.es</a>
                    </div>
                </div>
            </div>


            <h3>Comunicación y Eventos</h3>
            <div class="responsables seccion-equipo">
                <div class="persona">
                    <img src="/static/img/quienes-somos/beatriz-deprada.jpg" class="imagen-persona">
                    <div class="datos">
                        <p class="nombre">Beatriz de Prada</p>
                        <p class="cargo">Responsable de Comunicación y Eventos</p>
                        <div class="linkedln-equipo">
                            <img src="/static/img/logo-linkedln.png">
                            <a href="https://www.linkedin.com/in/beatriz-de-prada/" target="_blank">LinkedIn</a>
                        </div>
                        <a href="mailto:beatriz.deprada@ufv.es" class="correo-equipo">beatriz.deprada@ufv.es</a>
                    </div>
                </div>
            </div>

            <h3>Transferencia de Información y Observatorio de Empleo</h3>
            <div class="responsables seccion-equipo">
                <div class="persona">
                    <img src="/static/img/quienes-somos/veronica-dearozamena.jpg" class="imagen-persona">
                    <div class="datos">
                        <p class="nombre">Verónica de Arozamena</p>
                        <p class="cargo">Responsable de Transferencia de Información y Observatorio de Empleo</p>
                        <div class="linkedln-equipo">
                            <img src="/static/img/logo-linkedln.png">
                            <a href="https://www.linkedin.com/in/veronicadearozamenasanz/" target="_blank">LinkedIn</a>
                        </div>
                        <a href="mailto:v.arozamena@ufv.es" class="correo-equipo">v.arozamena@ufv.es</a>
                    </div>
                </div>
            </div>


        </section>


    </div>
</template>


<script lang="js">

export default {
    name: 'equipo',
    data() {
        return {

        }
    },
    computed: {

    },
    methods: {
    }
}
</script>

<style scoped lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/views/equipo.vue